// extracted by mini-css-extract-plugin
export default {"disabledFormOverlay":"oWz1CV"};